import { atom } from "jotai";
import {
    RouterProvider,
    createBrowserRouter,
    redirect,
} from "react-router-dom";
import Summary from "./routes/Summary";
import ThankYou from "./routes/ThankYou";
import Fail from "./routes/SendFailed";
import Root from "./routes/root";
import Intro from "./routes/Intro";
import { FormModel, TravelReturnSearchModel, TravelSearchModel } from "./types/FormTypes";
import Kitchensink from "./routes/Kitchensink";
import ContactDetails from "./routes/ContactDetails";
import TravelSearch from "./routes/TravelSearch";
import TravelSearchReturn from "./routes/TravelSearchReturn";
import TravelSummary from "./routes/TravelSummary";
import TravelReturnSearch from "./routes/TravelSearchReturn";
import UnregisterTravelPlan from "./routes/UnregisterTravelPlan";
import UnregisterTravelSuccess from "./routes/UnregisterTravelSuccess";
import UnregisterTravelError from "./routes/UnregisterTravelError";

// import AddCertificate from "./routes/AddCertificate";
require("./extensions/yup-extensions");

/*
    Store  - Collecting Travel Search Data 
*/

export const travelSearchAtom = atom<TravelSearchModel>({
    selectedJourneyFrom: null,
    selectedJourneyTo: null,
    journeyDate: '',
    journeyTime: '',
});

export const travelReturnSearchAtom = atom<TravelReturnSearchModel>({
    selectedReturnJourneyFrom: null,
    selectedReturnJourneyTo: null,
    returnJourneyDate: '',
    returnJourneyTime: '',
});

/*
    Store - Collecting FormData
*/

export const formDataAtom = atom<FormModel>({

    schoolorg: "",
    contactperson: "",
    phonenumberschoolorg: "",
    mailadress: "",
    journey: "",
    returnJourney: "",
    traveltype: "",
    //TEMP 
    travelQty: "", 
    phonenumber: "",
    
    selectedJourney: { fromName: '', toName: '', date: '', travelTime: '',  journeyKey: '', line: '', switches: '', unformattedDate: '' },
    selectedReturnJourney: { fromName: '', toName: '', date: '', travelTime: '', journeyKey: '', line: '', switches: '', unformattedDate: '' },

    //Test components
    filesuploadtest: [],
    textareatest: "",
    inputtest: "",
    radiotest: "",
    testpicker: "",    
});

export const selectedJourneyAtom = atom({
    fromName: '',
    toName: '',
    date: '',
    travelTime: '',
    journeyKey: '',
    line: '',
    switches: '',
    unformattedDate: '',
});

export const selectedReturnJourneyAtom = atom({
    fromName: '',
    toName: '',
    date: '',
    travelTime: '',
    journeyKey: '',
    line: '',
    switches: '',
    unformattedDate: '',
});

const state = { followingForm: false };
const routerBasename = (window as any).OGT?.WebApp?.routerBasename ?? "";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            {
                index: true,
                element: <Intro />,
                loader: () => {
                    state.followingForm = true;
                    return null;
                }
            },
            {
                path: "vart-vill-ni-resa",
                element: <TravelSearch />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "valj-aterresa",
                element: <TravelReturnSearch />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "er-resa",
                element: <TravelSummary />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "kontaktuppgifter",
                element: <ContactDetails />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "kitchensink",
                element: <Kitchensink />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "summering",
                element: <Summary />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "tack-sida",
                element: <ThankYou  />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "ett-fel-intraffade",
                element: <Fail  />,
                loader: async () => {
                    return state.followingForm ? null : redirect("/");
                },
            },
            {
                path: "avboka-resa",
                element: <UnregisterTravelPlan />,
                loader: async () => {
                    return { title: "Avanmäl gruppresa" };
                },
            },
            {
                path: "avboka-resa-gemomford",
                element: <UnregisterTravelSuccess />,
                loader: async () => {
                    return { title: "Avanmäl gruppresa" };
                },
            },
            {
                path: "avboka-resa-fel",
                element: <UnregisterTravelError />,
                loader: async () => {
                    return { title: "Avanmäl gruppresa" };
                },
            } 
        ],
    },
],
    {
        basename: routerBasename
    }
);

// Count pages WIP
const pagePaths =
    router?.routes[0]?.children?.map((child) => child.path).filter(Boolean) || [];

export const pageCountAtom = atom({
    pagePaths,
});

function App() {
    // const [formData] = useAtom(formDataAtom);
    // const [medicalVisit] = useAtom(medicalVisitAtom);

    return (
        <>
            <RouterProvider router={router} />
            {/* <div className="bg-slate-900 text-white p-6 text-xs  grid-cols-2 gap-10 hidden md:grid">
        <pre>{JSON.stringify(formData, null, 2)}</pre>
        <pre>{JSON.stringify(medicalVisit, null, 2)}</pre>
      </div> */}
        </>
    );
}

export default App;
